exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"knowledgeTable.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b10d64e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/knowledgeTable/knowledgeTable.vue
// module id = 422
// module chunks = 2 5